import React, { useState } from 'react';
import { PropTypes } from 'prop-types';

import {
  Typography,
  Tabs,
  Tab,
  Box,
} from '@mui/material';

import ContactListItem from './ContactListItem';

const ChatSecondary = ({ contactsData }) => {
  const [currentTab, _setCurrentTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    if (newValue === 1) {
      window.location.href = '/chat/browse';
    }
  };

  if (!contactsData || !contactsData.contacts) {
    return null;
  }

  return (
    <Box
      sx={{
        borderRight: '1px solid rgb(204, 204, 204)',
        height: 'calc(100vh - 75px)',
        overflowY: 'scroll',
      }}
    >
      <Tabs
        value={currentTab}
        onChange={handleTabChange}
        sx={{ marginBottom: 2 }}
      >
        <Tab key={0} label="Chats" value={0} />
        <Tab key={1} label="Browse" value={1} />
      </Tabs>
      <Typography variant="h3">Messages</Typography>
      {contactsData?.contacts.map((contact) => (
        <ContactListItem key={contact.id} contact={contact} />
      ))}
    </Box>
  );
};

ChatSecondary.defaultProps = {
  contactsData: {},
};

ChatSecondary.propTypes = {
  contactsData: PropTypes.object,
};

export default ChatSecondary;
